var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-checked-in"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checked-in",
    clipPath: "url(#clip-checked-in)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32864",
    "data-name": "Group 32864",
    transform: "translate(-3398.865 13418.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_11156",
    "data-name": "Ellipse 11156",
    transform: "translate(3398.865 -13418.611)",
    fill: "#4ab37b",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "play",
    d: "M24.6,4.487,16.732.063A.492.492,0,0,0,16,.492V9.34a.492.492,0,0,0,.732.429L24.6,5.345a.492.492,0,0,0,0-.857Z",
    transform: "translate(3393.933 -13408.527)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIn);
export default __webpack_public_path__ + "static/media/checked-in.5e11f01d8b6aa2808e80d3d2db9a96aa.svg";
export { ForwardRef as ReactComponent };